import { render } from "./OrgStructure.vue?vue&type=template&id=0d462168&scoped=true"
import script from "./OrgStructure.vue?vue&type=script&lang=js"
export * from "./OrgStructure.vue?vue&type=script&lang=js"

import "./org-structure.scss?vue&type=style&index=0&id=0d462168&lang=scss&scoped=true"
import "./OrgStructure.vue?vue&type=style&index=1&id=0d462168&lang=scss"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d462168"]])

export default __exports__